import type { ScalarMetricKey } from '@/types/analyticsV2';

// Per-metric accent, used only as a thin left border. Literal strings — Tailwind can't see interpolated class names.
export const METRIC_BORDER: Partial<Record<ScalarMetricKey, string>> = {
  aiMessages: 'border-violet-400',
  aiAcceptanceRate: 'border-blue-400',
  aiCoverage: 'border-teal-400',
  aiAutomation: 'border-amber-400',
  aiAccuracy: 'border-emerald-400',
  aiEdits: 'border-rose-400',
};

export const NEUTRAL_BORDER = 'border-gray-300';

// Soft, deterministic per-account tint for the avatar badge.
const AVATAR_COLORS = [
  'bg-violet-100 text-violet-700',
  'bg-blue-100 text-blue-700',
  'bg-teal-100 text-teal-700',
  'bg-amber-100 text-amber-700',
  'bg-rose-100 text-rose-700',
  'bg-emerald-100 text-emerald-700',
];

export function avatarColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export function accountInitials(name: string | undefined, id: string): string {
  const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (parts.length === 0) return `#${id.slice(-2)}`;
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
